import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import AuthenticationDomain from "domainActions/authentication/AuthenticationDomain";
import { Button } from "components/bootstrap";
import { Spinner } from "components/common";
import ConnectionErrors, {
  NotificationContainer
} from "components/authentication/directoryServices/BackendWizard/ConnectionErrors";
import { formHasErrors } from "util/FormsUtils";
const StyledHeader = styled.h4`
  margin-bottom: 10px;
`;
const ServerConnectionTest = ({ prepareSubmitPayload, validateForm, backendId }) => {
  const { t } = useTranslation("enterprise_authentication");
  const [{ loading, success, message, errors }, setConnectionStatus] = useState({
    loading: false,
    success: false,
    message: void 0,
    errors: void 0
  });
  const _connectionCheck = () => {
    const payload = prepareSubmitPayload();
    setConnectionStatus({ loading: true, message: void 0, errors: void 0, success: false });
    AuthenticationDomain.testConnection({ backend_configuration: payload, backend_id: backendId }).then((response) => {
      if (response.success === false) {
        const requestErrors = [response.message, ...response.errors];
        setConnectionStatus({ loading: false, message: void 0, errors: requestErrors, success: false });
        return;
      }
      setConnectionStatus({
        loading: false,
        message: response == null ? void 0 : response.message,
        success: response == null ? void 0 : response.success,
        errors: response == null ? void 0 : response.errors
      });
    });
  };
  const _handleConnectionCheck = () => {
    validateForm().then((e) => {
      if (!formHasErrors(e)) {
        _connectionCheck();
      }
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledHeader, null, t("oidc.server_connection_test.title")), /* @__PURE__ */ React.createElement("p", null, t("oidc.server_connection_test.description")), /* @__PURE__ */ React.createElement(Button, { onClick: _handleConnectionCheck, type: "button" }, loading ? /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: t("oidc.server_connection_test.test_server_connection") }) : t("oidc.server_connection_test.test_server_connection")), success && /* @__PURE__ */ React.createElement(NotificationContainer, { bsStyle: "success" }, /* @__PURE__ */ React.createElement("b", null, message)), errors && errors.length >= 1 && /* @__PURE__ */ React.createElement(ConnectionErrors, { errors, message }));
};
export default ServerConnectionTest;
